import React from "react";
import { Download, Calendar } from "lucide-react";
import { useGetMyReceiptsQuery } from "../api/billingApi";

export default function MyReceiptsPage() {
  const { data, isLoading } = useGetMyReceiptsQuery();
  console.log(data, "thi is the data and so");
  if (isLoading) {
    return <div className="p-10">Loading receipts...</div>;
  }

  return (
    <div className="max-w-7xl mx-auto space-y-6">
      {/* HEADER */}

      <div className="bg-white border rounded-[32px] p-6 shadow-sm flex items-center gap-4">
        <div className="p-3 bg-gray-900 rounded-2xl">
          <Calendar className="w-6 h-6 text-white" />
        </div>

        <div>
          <h1 className="text-2xl font-black">My Receipts</h1>
          <p className="text-sm text-gray-500">
            Download all your payment receipts
          </p>
        </div>
      </div>

      {/* TABLE */}

      <div className="bg-white border rounded-[32px] overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 text-gray-600 uppercase text-xs">
            <tr>
              <th className="text-left px-6 py-4">Receipt</th>
              <th className="text-left px-6 py-4">Charge</th>
              <th className="text-left px-6 py-4">Amount</th>
              <th className="text-left px-6 py-4">Date</th>
              <th className="text-right px-6 py-4">Action</th>
            </tr>
          </thead>

          <tbody>
            {data?.map((receipt: any) => (
              <tr key={receipt.id} className="border-t">
                <td className="px-6 py-4 font-semibold">
                  #{receipt.receipt_number}
                </td>

                <td className="px-6 py-4">{receipt.charge_name}</td>

                <td className="px-6 py-4 font-bold">
                  ₦{receipt.amount.toLocaleString()}
                </td>

                <td className="px-6 py-4 flex items-center gap-2">
                  <Calendar className="w-4 h-4 text-gray-400" />
                  {new Date(receipt.date).toLocaleDateString()}
                </td>

                <td className="px-6 py-4 text-right">
                  <a
                    href={receipt.receipt_url}
                    target="_blank"
                    className="inline-flex items-center gap-2 px-4 py-2 border rounded-xl hover:bg-gray-50"
                  >
                    <Download className="w-4 h-4" />
                    Download
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
